import { BaseStorageService } from "module/common/service/BaseStorageService";

export const AuthTokenStorage = new (class extends BaseStorageService<string> {
    constructor() {
        const url = process.env.PUBLIC_URL === "" ? "primo" : process.env.PUBLIC_URL;
        super(url + "_auth_token");
    }
})();
